import React from 'react';
import { CreateInventoryFormPanel } from './FormLayout';
import Input from '../Common/InputField';
import DateInput from '../Common/DateInput';
import Select from '../Common/Select';
import { asset_status_options, yes_no_options } from './utils';
import PropTypes from 'prop-types';
import LocationDropdown from './LocationDropdown';
import FormFieldItem from "./FormLayout";

const GreaseTrap = ({
    newPurchaseAquisition,
    setNewPurchaseAquisition,
    locations,
    location,
    setLocation,
    subLocation,
    setSubLocation,
    name,
    setName,
    assetStatus,
    setAssetStatus,
    tagNumber,
    setTagNumber,
    serialNumber,
    setSerialNumber,
    acquisitionDate,
    setAquisitionDate,
    disbursementDate,
    setDisbursementDate,
    installDate,
    setInstallDate,
    locationOnSite,
    setLocationOnsite,
    manufacturer,
    setManufacturer,
    manufacturers,
    manufactureDate,
    setManufactureDate,
    modelNumber,
    setModelNumber,
    modelYear,
    setModelYear,
    years,
    brand,
    setBrand,
    poNumber,
    setPONumber,
    lifeTime,
    setLifeTime,
    lifeTimeOptions,
    maxDate = { maxDate },
}) => (
    <CreateInventoryFormPanel enabled={false}>
        <FormFieldItem>
            <Select
                required
                value={newPurchaseAquisition}
                label="Is this a new purchase / acquisition?"
               
                options={yes_no_options}
                onChange={e => setNewPurchaseAquisition(e.target.value)}
            />
        </FormFieldItem>
        <LocationDropdown
            required
            locations={locations}
            location={location}
            subLocation={subLocation}
            onChangeLocation={setLocation}
            onChangeSubLocation={setSubLocation}
           
        />
        <FormFieldItem>
            <Input
                required
                fullWidth
                label="Name"
                value={name}
                onChange={e => setName(e.target.value)}
                error={!name}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                required
                value={assetStatus}
                label="Asset Status"
               
                options={asset_status_options}
                onChange={e => setAssetStatus(e.target.value)}
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                fullWidth
                label="Tag Number"
                value={tagNumber}
                onChange={e => setTagNumber(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                fullWidth
                label="Serial Number"
                value={serialNumber}
                onChange={e => setSerialNumber(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <DateInput
                date={acquisitionDate}
                onChange={date => setAquisitionDate(date)}
                label="Acquisition Date *"
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <DateInput
                date={disbursementDate}
                onChange={date => setDisbursementDate(date)}
                label="Disbursement Date"
               
                disabled
            />
        </FormFieldItem>
        <FormFieldItem>
            <DateInput
                date={installDate}
                onChange={date => setInstallDate(date)}
                label="Install Date *"
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                fullWidth
                multiLine
                label="Location On Site"
                value={locationOnSite}
                onChange={e => setLocationOnsite(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                value={manufacturer}
                label="Manufacturer"
               
                options={manufacturers}
                onChange={e => setManufacturer(e.target.value)}
            />
        </FormFieldItem>
        <FormFieldItem>
            <DateInput
                date={manufactureDate}
                onChange={date => setManufactureDate(date)}
                label="Manufacturer Date"
               
                maxDate={maxDate}
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                fullWidth
                label="Model Number"
                value={modelNumber}
                onChange={e => setModelNumber(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                value={modelYear}
                label="Model Year"
               
                options={years}
                onChange={e => setModelYear(e.target.value)}
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                fullWidth
                label="Brand"
                value={brand}
                onChange={e => setBrand(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Input
                fullWidth
                label="PO Number"
                value={poNumber}
                onChange={e => setPONumber(e.target.value)}
               
            />
        </FormFieldItem>
        <FormFieldItem>
            <Select
                value={lifeTime}
                label="Expected Lifetime (years)"
               
                options={lifeTimeOptions}
                onChange={e => setLifeTime(e.target.value)}
            />
        </FormFieldItem>
    </CreateInventoryFormPanel>
);

GreaseTrap.propTypes = {
    locations: PropTypes.array.isRequired,
    location: PropTypes.string.isRequired,
    setLocation: PropTypes.func.isRequired,
    subLocation: PropTypes.string.isRequired,
    setSubLocation: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    setName: PropTypes.func.isRequired,
    assetStatus: PropTypes.string.isRequired,
    setAssetStatus: PropTypes.func.isRequired,
    tagNumber: PropTypes.string.isRequired,
    setTagNumber: PropTypes.func.isRequired,
    serialNumber: PropTypes.string.isRequired,
    setSerialNumber: PropTypes.func.isRequired,
    acquisitionDate: PropTypes.string.isRequired,
    setAquisitionDate: PropTypes.func.isRequired,
    disbursementDate: PropTypes.string.isRequired,
    setDisbursementDate: PropTypes.func.isRequired,
    installDate: PropTypes.string.isRequired,
    setInstallDate: PropTypes.func.isRequired,
    locationOnSite: PropTypes.string.isRequired,
    setLocationOnsite: PropTypes.func.isRequired,
    manufacturer: PropTypes.string.isRequired,
    setManufacturer: PropTypes.func.isRequired,
    manufacturers: PropTypes.array.isRequired,
    manufactureDate: PropTypes.string.isRequired,
    setManufactureDate: PropTypes.func.isRequired,
    modelNumber: PropTypes.string.isRequired,
    setModelNumber: PropTypes.func.isRequired,
    modelYear: PropTypes.string.isRequired,
    setModelYear: PropTypes.func.isRequired,
    years: PropTypes.array.isRequired,
    brand: PropTypes.string.isRequired,
    setBrand: PropTypes.func.isRequired,
    poNumber: PropTypes.string.isRequired,
    setPONumber: PropTypes.func.isRequired,
    lifeTime: PropTypes.string.isRequired,
    setLifeTime: PropTypes.func.isRequired,
    lifeTimeOptions: PropTypes.array.isRequired,
    regulatedAssets: PropTypes.array.isRequired,
    regulatedAssetTypes: PropTypes.array.isRequired,
    setRegulatedAssets: PropTypes.func.isRequired
};

export default GreaseTrap;
